import { IModalServiceInstance } from "angular-ui-bootstrap";
import { NotifyService } from "infrastructure/services/notifyService";
import "ugsk-osago-base-tariff-modal.css";

export class BaseTariffModal {
    public baseTariff = 0;
    public baseTariffMin = 0;
    public baseTariffMax = 0;

    public insurancePremium = 0;
    public insurancePremiumMin = 0;
    public insurancePremiumMax = 0;

    public coef = 1;

    static get $inject() {
        return ["$uibModalInstance", "notifyService", "context", "$scope"];
    }

    constructor(
        private $uibModalInstance: IModalServiceInstance,
        private notifyService: NotifyService,
        private context: any,
        private $scope,
    ) {
        'ngInject';
    }

    public $onInit() {
        const getContractReduction = this.context.di("getBaseTariffData");

        this.notifyService.progressStart();
        getContractReduction({ id: this.context.Contract.Id }).sendRequest().$promise
            .then((data) => {
                this.coef = (data.Premium || 1) / (data.Tb || 1);
                this.baseTariffMax = +(data.MaxLimit || 0).toFixed(2);
                this.baseTariffMin = +((data.MinLimit || 0) + 0.01).toFixed(2);
                this.insurancePremiumMax = +((data.MaxLimit || 0) * this.coef).toFixed(2);
                this.insurancePremiumMin = +((data.MinLimit || 0) * this.coef + 0.01).toFixed(2);

                setTimeout(() => {
                    this.insurancePremium = +(data.Premium || 0).toFixed(2);
                    this.baseTariff = +(data.Tb || 0).toFixed(2);

                    this.$scope.$digest();
                });

                this.notifyService.progressStop();
            })
            .catch((err) => {
                const errorMessage = err.data && err.data.Message || "Настройка базового тарифа недоступна";
                this.notifyService.progressStop();
                this.notifyService.errorMessage("Ошибка", errorMessage);
                this.close();
            });

        this.$scope.$watch(
            () => this.baseTariff,
            (newVal) => {
                this.insurancePremium = +(newVal * this.coef).toFixed(2);
            }
        );

        this.$scope.$watch(
            () => this.insurancePremium,
            (newVal) => {
                this.baseTariff = +(newVal / this.coef).toFixed(2);
            }
        );

    }

    public ok() {
        this.context.saveAsyncContract(false, this.insurancePremium);
        this.$uibModalInstance.close();
    }

    public close() {
        this.$uibModalInstance.close();
    }
}